<template>
  <print-template v-if="po" :viewSubheader="false">
    <h4 class="text-center mt-4">PURCHASE ORDER</h4>
    <div class="d-flex mt-4">
      <div
        style="border: 1px solid #333; border-radius: 5px; width: 50%; padding: 8px 15px;"
      >
        <table id="supplier_table">
          <tr>
            <td>Company</td>
            <td>:</td>
            <td><b v-text="supplier.name"></b></td>
          </tr>
          <tr>
            <td>Address</td>
            <td>:</td>
            <td v-text="supplier.address"></td>
          </tr>
          <tr>
            <td>Tel. No.</td>
            <td>:</td>
            <td v-text="supplier.telephone"></td>
          </tr>
          <tr>
            <td>Contact</td>
            <td>:</td>
            <td v-text="supplier.contact_person"></td>
          </tr>
        </table>
      </div>
      <div style="width: 50%; padding: 8px 15px;">
        <table style="margin-left: auto">
          <tr>
            <td><b>P.O. Number</b></td>
            <td>:</td>
            <td v-text="po.po_no"></td>
          </tr>
          <tr>
            <td><b>P.O. Date</b></td>
            <td>:</td>
            <td>{{ po.po_date | dateFormat }}</td>
          </tr>
          <tr>
            <td><b>Quote No.</b></td>
            <td>:</td>
            <td v-text="po.quote_no"></td>
          </tr>
        </table>
      </div>
    </div>
    <table id="items_table">
      <thead>
        <tr>
          <th width="40px">Item No.</th>
          <th>Part No.</th>
          <th width="250px">Description</th>
          <th>Qty.</th>
          <th>Unit</th>
          <th>Unit Price</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in po.requests" :key="index">
          <td class="text-center" v-text="index + 1"></td>
          <td v-text="item.part.part_no"></td>
          <td v-text="item.part.description"></td>
          <td class="text-center" v-text="item.quantity"></td>
          <td class="text-center" v-text="item.unit"></td>
          <td class="text-center">
            {{ item.unit_price | currency(currency.sign, 4) }}
            <!-- {{ item.unit_price | currency("$ ", 2) }} -->
          </td>
          <td class="text-right">
            {{ item.total | currency(currency.sign, 2) }}
            <!-- {{ item.total | currency("$ ", 2) }} -->
          </td>
        </tr>
        <tr class="table_footer">
          <td colspan="6" class="text-center">
            ({{ currency.sign }}) {{ totalWords | uppercase }}
            <!-- (USD) {{ totalWords | uppercase }} -->
          </td>
          <td class="text-right">
            {{ totalAmount | currency(currency.sign, 2) }}
            <!-- {{ totalAmount | currency("$ ", 2) }} -->
          </td>
        </tr>
      </tbody>
    </table>
    <p class="mt-4">
      <b><i>Invoice and ship to:</i></b>
    </p>
    <p class="ml-4">
      <b>TOTAL EXPERTISE FOR TRADING &amp; INDUSTRIALS CO. LTD. ABUDHAB LLC</b
      ><br />
      P.O. Box 91219, Warehouse B1501 <br />
      Blue Lake Properties Compound <br />
      ICAD 3, Mussafah Industrial Area <br />
      Abu Dhabi, United Arab Emirates <br />
    </p>
  </print-template>
</template>
<script>
import PrintTemplate from "@/components/PrintTemplate.vue";
import PurchaseOrder from "@/models/PurchaseOrder";
const converter = require("number-to-words");
export default {
  name: "PrintPurchaseOrder",
  components: { PrintTemplate },
  computed: {
    totalAmount() {
      if (!this.po) return 0;
      var total = 0;
      this.po.requests.forEach(o => {
        total += parseFloat(o.total);
      });
      return total;
    },
    totalWords() {
      var d = `${this.totalAmount.toFixed(2)}`.split(".")[1];
      d = d.startsWith("0") ? d.substring(1) : d;
      if (d != 0) return `${converter.toWords(this.totalAmount)} AND ${d}/100`;
      else return converter.toWords(this.totalAmount);
    }
  },
  data() {
    return {
      po: new PurchaseOrder(),
      supplier: {},
      currency: {
        rate: 1,
        sign: "USD"
      }
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      PurchaseOrder.fetch(this.$route.params.id).then(resp => {
        this.po = new PurchaseOrder(resp);
        this.supplier = this.po.supplier;
        this.currency = {
          sign: resp.currency_rate.sign.toUpperCase() + " ",
          rate: resp.currency_rate.rate
        };
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#supplier_table {
  td {
    vertical-align: top;
  }
}
#items_table {
  margin-top: 3rem;
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  > thead {
    th {
      color: #fff;
      background: #16365c;
      font-weight: normal;
      padding-top: 5px;
    }
  }
  th,
  td {
    border: 1px solid #000;
  }
  .table_footer {
    td {
      color: #fff;
      background: #16365c;
    }
  }
}
</style>
